module.exports = __webpack_public_path__ + "static/calculating-622db0555c8df6248ab5a72ca0363922.svg";